"use client";

import { useRef, useState } from "react";
import { Swiper, SwiperRef, SwiperSlide } from "swiper/react";
import { HERITAGE_SLIDES } from "@/views/home/constants";
import SliderArrowButton from "@/components/entities/slider-arrow-button";
import S from "./index.module.scss";
import { Container } from "@/components/ui/container";
import { useMedia } from "@/hooks/system/useMedia";

const HeritageSection = () => {
  const { isMobile, isClient } = useMedia();
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const swiperRef = useRef<SwiperRef>(null);

  const handleNext = () => {
    if (swiperRef.current && currentIndex < HERITAGE_SLIDES.length) {
      swiperRef.current.swiper.slideNext();
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (swiperRef.current && currentIndex !== 0) {
      swiperRef.current.swiper.slidePrev();
      setCurrentIndex(currentIndex - 1);
    }
  };
  return (
    <section className={S.heritage}>
      <Container>
        <div className={S.top}>
          <div className={S.headingBlock}>
            <p className={S.label}>Истоки дизайна</p>
            <h2 className={S.heading}>
              <span>Вдохновлённые</span>
              <span>наследием</span>
              <span>ар-деко</span>
            </h2>
          </div>
          <p className={S.description}>
            Вдохновлённые геометрической точностью архитектуры и индустриального дизайна 1920-х годов, наши часы
            отражают золотой век механической элегантности. Чёткие углы, симметричные композиции и ритмичные узоры лежат
            в основе каждого изделия.
          </p>
        </div>
      </Container>
      <div className={S.sliderWrapper}>
        <Swiper
          speed={900}
          className={S.slider}
          ref={swiperRef}
          onSlideChange={swiper => setCurrentIndex(swiper.activeIndex)}
        >
          {HERITAGE_SLIDES.map((slide, index) => (
            <SwiperSlide key={`${index}`} className={S.slide}>
              {isClient && (
                <img src={!isMobile ? slide.desktop : slide.mobile} alt="Модель часов Art-Deco" className={S.image} />
              )}
            </SwiperSlide>
          ))}
        </Swiper>

        <div className={S.controls}>
          <SliderArrowButton
            direction="prev"
            tone="light"
            onClick={handlePrev}
            style={{ opacity: currentIndex === 0 ? 0 : 1 }}
          />
          <SliderArrowButton
            style={{ opacity: currentIndex === HERITAGE_SLIDES.length - 1 ? 0 : 1 }}
            direction="next"
            tone="light"
            onClick={handleNext}
          />
        </div>
      </div>
      <div className={S.overlay}></div>
    </section>
  );
};

export default HeritageSection;
